import { capitalize } from 'lodash'
import { formatters as datetimeFormatters } from './datetime'

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString#Checking_for_support_for_locales_and_options_arguments
function rtfSupport() {
  return !!(typeof Intl == 'object' && Intl && typeof Intl.RelativeTimeFormat == 'function');
}

const formatters = rtfSupport() && {
  auto: new Intl.RelativeTimeFormat(undefined, {
    numeric: 'auto',
  })
}

const day = 1000 * 60 * 60 * 24
const week = day * 7

export function datetimeRelative(dateStr, nowStr, variant = 'noCurrentYear') {
  const date = new Date(dateStr)
  const now = nowStr ? new Date(nowStr) : undefined
  try {
    return formatRelative[variant](date, now)
  } catch (err) {
    return dateStr
  }
}

const formatRelative = {
  noCurrentYear: formatNoCurrentYear,
  conversational: formatConversational,
}

function formatNoCurrentYear(date, now = new Date()) {
  const isCurrentYear = date.getYear() === now.getYear()
  if (isCurrentYear) {
    return datetimeFormatters['noYear'].format(date)
  } else {
    return datetimeFormatters['medium'].format(date)
  }
}

function formatConversational(date, now = new Date()) {
  const todayStart = new Date(now.toDateString())
  const isToday = now.toDateString() === date.toDateString()
  const isYesterday = todayStart - day <= date && date < todayStart
  const isWithin7days = todayStart - week <= date && date < todayStart
  if (isToday) {
    const label = formatters ? formatters['auto'].format(0, 'day') : 'today'
    return `${capitalize(label)} ${datetimeFormatters['time'].format(date)}`
  } else if (isYesterday) {
    const label = formatters ? formatters['auto'].format(-1, 'day') : 'yesterday'
    return `${capitalize(label)} ${datetimeFormatters['time'].format(date)}`
  } else if (isWithin7days) {
    return datetimeFormatters['thisWeek'].format(date)
  } else {
    return datetimeFormatters['medium'].format(date)
  }
}
